import { createContext } from 'react';

const EntityConfigurationDispatchContext = createContext();

export default EntityConfigurationDispatchContext;
